export interface ScopeInfo {
  label: string
  audited: boolean
}

export interface BackendBinding {
  spaceNames?: string[]
  aclGroupIds: string[]
}

export interface SceneItem {
  id: string
  title: string
  summary: string
  scope: ScopeInfo
  prompt: string
  suggestions?: string[]
  backend: BackendBinding
}

/** MES 制造向场景（知识空间名需与 seeker-ai /v1/spaces 对齐） */
export const scenes: SceneItem[] = [
  {
    id: 'mes-general',
    title: 'MES 总助手',
    summary: '制造执行相关通用问答，可结合公开知识回答。',
    scope: { label: '企业公开知识', audited: true },
    prompt: '你是屿枫，MES 制造助手，请用简洁专业的中文回答生产、工艺与质量相关问题。',
    suggestions: ['过站失败常见原因', '如何查询工单追溯', '报工录入要注意什么'],
    backend: { aclGroupIds: ['public', 'mes'] }
  },
  {
    id: 'sop-qa',
    title: '工艺 / SOP',
    summary: '查询工艺规程与标准作业指导。',
    scope: { label: '工艺知识库', audited: true },
    prompt: '请根据工艺与 SOP 知识库，解答工序操作与注意事项。',
    suggestions: ['本工序关键检查点', '换型步骤摘要', '防呆要求有哪些'],
    backend: { spaceNames: ['工艺知识库'], aclGroupIds: ['mes', 'public'] }
  },
  {
    id: 'quality-help',
    title: '质量异常',
    summary: '不良判定、检验标准与处理建议。',
    scope: { label: '质量标准库', audited: true },
    prompt: '请根据质量标准，帮助分析不良代码与处理建议。',
    suggestions: ['外观不良如何判定', 'IQC 抽样规则', '终检放行条件'],
    backend: { spaceNames: ['质量标准库'], aclGroupIds: ['qa', 'public'] }
  },
  {
    id: 'equip-help',
    title: '设备排查',
    summary: '设备告警、稼动与常见故障排查。',
    scope: { label: '设备手册库', audited: true },
    prompt: '请根据设备手册，给出故障排查步骤与安全注意点。',
    suggestions: ['设备停机检查清单', '常见报警含义', '保养周期提醒'],
    backend: { spaceNames: ['设备手册库'], aclGroupIds: ['equip', 'public'] }
  }
]

export function getScene(id: string): SceneItem | undefined {
  return scenes.find((s) => s.id === id)
}
